const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  displayLayout: state => state.app.displayLayout,
  size: state => state.app.size,
  selectMenuId: state =>state.app.selectMenuId,
  device: state => state.app.device,
  constomLogo: state => state.app.tenantAvatar,
  userAccount: state => state.user.userAccount,
  tenantList: state => state.user.tenantList,
  currentTenant: state => state.user.currentTenant,
  currentProductKey: state => state.user.currentProductKey,
  isGuest: state => state.user.isGuest,
  avatar: state => state.user.avatar,
  roleList: state => state.user.roleList,
  isSitemapInit: state => state.user.isSitemapInit,
  sitemapList: state => state.user.sitemapList,
  isHomeInit: state => state.user.isHomeInit,
  baseAuthToken: state=> state.user.baseAuthToken,
  havePermissions: state => state.user.havePermissions,
  addRouters: state => state.router.addRouters,
  wstate: state => state.message,//ws暴露的相关信息
  orientationMessage: state => state.message.wsMessage.orientationMessage,//暴露定向消息
  alarmMessage: state => state.message.wsMessage.alarmMessage,//告警消息
  telecommandMessage: state => state.message.wsMessage.telecommandMessage,//遥信消息
  telemeteringMessage: state => state.message.wsMessage.telemeteringMessage,//遥测消息
  exportTaskList: state => state.notify.exportTaskList,//导出任务消息
  alarmTaskList: state => state.notify.alarmTaskList,//告警通知消息
}
export default getters
